
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<Tooltip>({})
export default class Tooltip extends Vue {
	@Prop({ type: String, default: false }) private tooltipText!: string;
	@Prop({ type: String, required: false }) private tooltipIcon!: string;
	@Prop({ type: String, default: '' }) private iconClass!: string;
}
